import type { ReactNode } from "react";
import type { LucideIcon } from "@fg/icons";
import { cn } from "@/lib/utils";

type Tone = "primary" | "amber" | "rose" | "slate";

const TONES: Record<Tone, { wrap: string; icon: string }> = {
    primary: { wrap: "bg-primary/10 dark:bg-primary/15", icon: "text-primary" },
    amber: { wrap: "bg-amber-100 dark:bg-amber-950/40", icon: "text-amber-500" },
    rose: { wrap: "bg-rose-100 dark:bg-rose-950/40", icon: "text-rose-500" },
    slate: { wrap: "bg-muted", icon: "text-muted-foreground" }
};

export function EmptyState({
    icon: Icon,
    title,
    description,
    tone = "primary",
    children
}: {
    icon: LucideIcon;
    title: string;
    description?: ReactNode;
    tone?: Tone;
    children?: ReactNode;
}) {
    const t = TONES[tone];
    return (
        <div className="drive-fade-in flex flex-col items-center justify-center px-6 py-14 text-center sm:py-20">
            <div className={cn("mb-5 flex h-24 w-24 items-center justify-center rounded-full", t.wrap)}>
                <Icon className={cn("h-11 w-11", t.icon)} aria-hidden />
            </div>
            <h2 className="text-lg font-semibold">{title}</h2>
            {description ? <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{description}</p> : null}
            {children ? <div className="mt-6 flex flex-wrap justify-center gap-2">{children}</div> : null}
        </div>
    );
}
